export const environment = {
  production: true,
  primaryColor: '#023f5f',
  backend: 'https://demo.openstreetmap.fr',
  url_carto: 'https://tiles.dataosm.info/ows/?map=',
  url_frontend: 'https://demo.openstreetmap.fr',
  nom_instance: "OSMdata",
  matomoUrl: 'https://piwik.dataosm.info/',
  matomoSiteId: 1,
  building_tile: "https://buildings.dataosm.info/maps/osm_data",
  osm_auth_base_url: "https://demo.openstreetmap.fr",
  enabledTerrain: true,
  revitURl: "",
};
